import Vue from 'vue';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';
import i18n from './i18n';
import {http} from "@/plugins/http";
import { store } from "./store";
import authService from "@/services/auth";
import loadingService from "@/services/loading";
import alertService from "@/services/alert";

Vue.config.productionTip = false;

authService.setupInterceptors(http, router);
authService.setupRouter(router);

loadingService.setupInterceptors(http);
alertService.setupInterceptors(http);

new Vue({
  store,
  router,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
